import {
  Box,
  Button,
  CardContent,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { decodeToken, OperationType } from '../../../../utils/settings';
import {
  createBusinessProfilerAction,
  getbusinessProfilerAction,
  patchbusinessProfilerAction,
} from '../../action';
import { toast, ToastContainer } from 'react-toastify';

function DistributorDetails() {
  const [open, setOpen] = useState(false);
  const [distributorsDetailsList, setDistributorsDetailsList] = useState({});
  const [distributorDetails, setDistributorDetails] = useState({});
  const [firmDetails, setFirmDetails] = useState({});
  const [addedDistributors, setAddedDistributors] = useState([]);
  const [editing, setEditing] = useState(false);

  const getprofiler = async () => {
    const { data, error, message } = await getbusinessProfilerAction();

    if (!error) setDistributorsDetailsList(data.supplier_details);
    else toast.error(message);
  };

  useEffect(() => {
    getprofiler();

    decodeToken().then(({ default_company_info }) => {
      setFirmDetails(default_company_info);
    });
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setDistributorDetails({});
    setAddedDistributors([]);
    setEditing(false);
  };

  const addDistributor = () => {
    if (!distributorDetails.brand_name)
      return toast.error('Please Enter Brand Name');
    const payload = {
      name: distributorDetails.name,
      phone_no: distributorDetails.phone_no,
      brand_name: distributorDetails.brand_name,
    };

    setDistributorDetails({});
    setAddedDistributors([...addedDistributors, payload]);
    toast.success('Distributor Saved');
  };

  const onFinish = async () => {
    const payload = {
      supplier_details: {
        firm_id: firmDetails.company_id,
        supplier_list: addedDistributors,
      },
    };

    const { error, message } = await createBusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  const onEdit = (data) => {
    setEditing(true);
    setOpen(true);

    const payload = {
      id: data.id,
      name: data.name,
      phone_no: data.phone_no,
      brand_name: data.brand_name,
    };

    setDistributorDetails(payload);
  };

  const onEditFinish = async () => {
    const payload = {
      supplier_details: {
        firm_id: firmDetails.company_id,
        supplier_list: [
          {
            id: distributorDetails.id,
            operation_type: OperationType['UPDATE'],
            name: distributorDetails.name,
            phone_no: distributorDetails.phone_no,
            brand_name: distributorDetails.brand_name,
          },
        ],
      },
    };

    const { error, message } = await patchbusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  return (
    <div>
      <ToastContainer className='custom-toast-container' />
      <CardContent
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 25,
        }}
      >
        {Object.keys(distributorsDetailsList).length > 0 &&
          distributorsDetailsList.supplier_list.map((vv) => {
            return (
              <Box
                sx={{
                  borderWidth: 2,
                  borderColor: '#F59C1E',
                  borderStyle: 'solid',
                  padding: 2,
                  borderRadius: 2,
                  position: 'relative',
                  marginBottom: 3,
                }}
              >
                <div
                  className='editCtr'
                  onClick={() => onEdit(vv)}
                >
                  <Tooltip title='Edit Details'>
                    <EditIcon color='primary' />
                  </Tooltip>
                </div>

                <div
                  className='row-center'
                  style={{
                    justifyContent: 'space-between',
                    marginBottom: 10,
                  }}
                >
                  <div className='row-center'>
                    <div className='row-center'>
                      <Typography
                        fontSize={15}
                        fontWeight={'600'}
                        sx={{ marginLeft: 1 }}
                      >
                        {vv.brand_name}
                      </Typography>
                    </div>
                  </div>

                  <div className='row-center'>
                    <div
                      className='row-center'
                      style={{ marginRight: 10 }}
                    >
                      <Typography
                        fontSize={15}
                        sx={{ marginRight: 0.5 }}
                      >
                        DB
                      </Typography>
                      :
                      <Typography
                        fontSize={15}
                        fontWeight={'600'}
                        sx={{ marginLeft: 1 }}
                      >
                        {vv.name}
                      </Typography>
                    </div>
                    |
                    <div
                      className='row-center'
                      style={{ marginLeft: 10 }}
                    >
                      <Typography
                        fontSize={15}
                        fontWeight={'600'}
                        sx={{ marginLeft: 1 }}
                      >
                        +91 {vv.phone_no}
                      </Typography>
                    </div>
                  </div>
                </div>
              </Box>
            );
          })}
      </CardContent>

      <div
        className='row-center'
        style={{
          justifyContent: 'flex-end',
        }}
      >
        <div>
          <Button
            onClick={handleOpen}
            sx={{ width: 150 }}
            variant='contained'
          >
            Add Details
          </Button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            backgroundColor: 'white',
            width: '70%',
            overflowY: 'scroll',
            maxHeight: '90vh',
            borderRadius: '10px',
            padding: '20px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <CardContent>
            <div className='title-Ctr'>
              <Typography
                variant='h5'
                fontWeight={'600'}
              >
                Add Distributor Details
              </Typography>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Firm Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Firm Name'
                  name='name'
                  value={firmDetails?.company_name}
                  disabled
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Enter Distributor Name (If any)
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Distributor Name'
                  name='name'
                  value={distributorDetails?.name || ''}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    setDistributorDetails((prev) => ({
                      ...prev,
                      name: value,
                    }));
                  }}
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Enter Distributor Phone Number (If any)
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Distributor Phone Number'
                  name='name'
                  value={distributorDetails?.phone_no || ''}
                  fullWidth
                  onChange={(e) => {
                    if (
                      /^\d*$/.test(e.target.value) &&
                      e.target.value.length <= 10
                    ) {
                      setDistributorDetails({
                        ...distributorDetails,
                        phone_no: e.target.value,
                      });
                    }
                  }}
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Enter Brand Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Brand Name'
                  name='name'
                  value={distributorDetails?.brand_name || ''}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    setDistributorDetails((prev) => ({
                      ...prev,
                      brand_name: value,
                    }));
                  }}
                  margin='normal'
                />
              </div>
            </div>

            {editing ? (
              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <div>
                  <Button
                    onClick={onEditFinish}
                    sx={{ marginTop: 2 }}
                    variant='contained'
                  >
                    Update Details
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <div>
                  <Button
                    onClick={addDistributor}
                    sx={{ width: 150, marginTop: 2 }}
                    variant='outlined'
                  >
                    Save
                  </Button>
                </div>
              </div>
            )}
          </CardContent>

          {addedDistributors.length > 0 && (
            <CardContent>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label='simple table'
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Distributor Name</TableCell>
                      <TableCell align='right'>Phone Number</TableCell>
                      <TableCell align='right'>Brand Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {addedDistributors.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell
                          component='th'
                          scope='row'
                        >
                          {row.name}
                        </TableCell>
                        <TableCell align='right'>{row.phone_no}</TableCell>
                        <TableCell align='right'>{row.brand_name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}
              >
                <div>
                  <Button
                    onClick={onFinish}
                    sx={{ marginTop: 2 }}
                    variant='contained'
                  >
                    Submit Details
                  </Button>
                </div>
              </div>
            </CardContent>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default DistributorDetails;
